 import React from 'react';
 import Paper from 'material-ui/Paper';
 import TextField from 'material-ui/TextField';
 import {filter} from 'lodash'
 import {percentageToNumber,numberToPercentage,isNumeric,isPercentage} from '../lib/utils'
 import {Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn}
   from 'material-ui/Table';

 import CLTable from '../components/CLTable'
 var numeral = require('numeral');

const paperStyle = {
 	boxShadow: 'rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px',
 	height:'100%',
 	fontFamily:'Roboto',
};

const styles = {
	ptHInnerStyle:{
		fontWeight:'bold',
		color:'blue',
		paddingLeft:0,
		fontFamily:'Roboto',
	},
	ptInnerStyle:{
		fontFamily:'Roboto',
		color:'blue',
		// paddingLeft:24
		// textAlign:'center',

		// border:'1px solid black'
	},
	thRegular:{
		color:'rgb(92, 95, 103)',
	},
	thFirst:{
		color:'rgb(92, 95, 103)',
		fontWeight:'600',
	},
}
// var total = 0;
const fields = [
	{name:'name'},
	{name:'sizePercentage'},
	{name:'size'},
	{name:'etf'},
	{name:'positionPrice'},
	{name:'stopLoss'},
	{name:'empty'},
	{name:'targetAmount'},
	{name:'targetPercentage'},
	{name:'strategies'}
]

export default class SectorsTable extends React.Component {



	constructor(props){
		super(props);

		var tableHeader = [
			{name:'Sector'},
			{name:'Sector size (%)'},
			{name:'Sector size ($)'},
			{name:'ETF size (%)'},
			{name:'Position Size (%)'},
			{name:'Stoploss (%)'},
			{name:'Partial Take Profit:'},
			{name:'Amount'},
			{name:'Trigger'},
			{name:'Strategies'},
		]
		this.state = {
			tableHeader: tableHeader
		}
	}

	capitalizeFirstLetter(string) {
	    return string.charAt(0).toUpperCase() + string.slice(1);
	}

	setSectorStyle(isValid){
		if(!isValid){
			return {color:'red'}
		}
		return {}
	}

	saveSector = (sector) => {
		//
		if(this.inputTimeout){
			clearTimeout( this.inputTimeout );
		}
		let self = this
		this.inputTimeout = setTimeout( function(){
			self.props.save(sector)
			console.log("input timer")
		}, 500 );
	};

	onChange = (tr,event) =>{


		// console.log(event,"dddd",tr)
		// tr["name"] = "lilili"
		// const e = event
		if(!event.target){

			return
		}
		// console.log(tr)
		var splitedId = event.target.id.split("-")
		var sectorName = splitedId[0]
		var field = splitedId[1]
		tr[field] = event.target.value
		if(field == 'size'){
			tr['sizePercentage'] = event.target.value == "" ? "" : numeral( numberToPercentage(event.target.value,this.props.totalBudget) ).format('0.[00]');
		}else if(field == 'sizePercentage'){
			tr['size'] = event.target.value == "" ? "" : numeral( percentageToNumber(event.target.value,this.props.totalBudget) ).format('0.[00]');
		}
		// console.log(sectorName)
		// var sector = filter(this.props.sectors,function(s){s.name == sectorName})
		// console.log(sector)

		this.forceUpdate()
		this.saveSector(tr)
		// this.props.sector[e.target.id] = e.target.value;
		// if(e.target.id == 'size'){
		// 	this.props.sector['sizePercentage'] = e.target.value == "" ? "" : numeral( numberToPercentage(e.target.value,this.props.totalBudget) ).format('0.[00]');
		// }else if(e.target.id == 'sizePercentage'){
		// 	this.props.sector['size'] = e.target.value == "" ? "" : numeral( percentageToNumber(e.target.value,this.props.totalBudget) ).format('0.[00]');
		// }
		// this.forceUpdate()
	}

	strategiesToString(strategies){
		console.log("lllff-------")
		return strategies.map( (s) => (

			s.field ? "short on sector" : ""
		) )
	}

	// componentWillUpdate(nextProps, nextState){
	// 	// console.log("BudgetAllocationControls componentWillMount");
	// 	var self = this
	// 	if(this.props !== nextProps){
	// 		// var sectorData = nextProps.sectors.map( (sector) => {
	// 			// console.log(nextProps.totalBudget,sector.size)
	// 			// return [
	// 			// 	{name:'name',value:sector.name,style:{}},
	// 			// 	{name:'size',value:numeral(sector.sizePercentage).format('0.[00]')+'%',style:this.setSectorStyle(sector.validateSize())},
	// 			// 	{name:'size',value:numeral(sector.size).format('0.[00]')+'$',style:this.setSectorStyle(sector.validateSize())},
	// 			// 	{name:'etf',value:sector.etf+'%',style:this.setSectorStyle(sector.validateEtf())},
	// 			// 	{name:'positionPrice',value:sector.positionPrice+'%',style:this.setSectorStyle(sector.validatePositionPrice())},
	// 			// 	{name:'stopLoss',value:sector.stopLoss+'%',style:this.setSectorStyle(sector.validateStoploss())},
	// 			// 	{name:'targetAmount',value:sector.targetAmount,style:this.setSectorStyle(sector.validateTargetAmount())},
	// 			// 	{name:'targetPercentage',value:sector.targetPercentage+'%',style:this.setSectorStyle(sector.validateTargetPercentage())},
	// 			// 	{name:'strategies',value:this.strategiesToString(sector.strategies),style:{}}
	// 			// ]
	// 		// })
	// 		// self.setState({sectorData:sectorData})
	// 		// console.log("sectors table update")
	// 	}
	// }


	render(){

		var tableHeader =

			<TableRow>
			{
				this.state.tableHeader.map( (hf,index) => {

					if(hf.name == 'Partial Take Profit:'){
					// 	return <TableHeaderColumn style={{paddingLeft:0,width:'25%'}} key={index} >

					// 		<div style={{display:'flex'}}>
					// 			<div style={styles.ptHInnerStyle}>Partial Take Profit:</div>
					// 			<div style={styles.ptInnerStyle}>amount</div>
					// 			<div style={styles.ptInnerStyle}>trigger</div>
					// 		</div>

					// </TableHeaderColumn>
						return <TableHeaderColumn style={styles.ptHInnerStyle} key={index}> {hf.name} </TableHeaderColumn>
					}else if (hf.name == 'Amount' || hf.name == 'Trigger'){
						return <TableHeaderColumn style={styles.ptInnerStyle} key={index}>{hf.name} </TableHeaderColumn>
					}else if (hf.name == 'Sector'){
						return <TableHeaderColumn style={styles.thFirst} key={index} >{hf.name}</TableHeaderColumn>
					}
					return <TableHeaderColumn style={styles.thRegular} key={index} >{hf.name}</TableHeaderColumn>
				})
			}
			</TableRow>

		var tableBody = filter(this.props.sectors,{selected:true} ).map( (tr,index) =>(
				<TableRow selectable={false} style={(index%2 != 0) ? {fontFamily:'Roboto',height:48}:{fontFamily:'Roboto',height:48,backgroundColor:'#E0E0E0'}} key={index}>
					{fields.map( (td,index2) => {

						if(td.name == "name" ){
							return <TableRowColumn key={index2} style={{fontFamily:'Roboto',backgroundColor:'inherit',color:'green', paddingTop:0,paddingBottom:0,height:20}}><span  id={td.name} >{tr[td.name]}</span></TableRowColumn>
						}else if(td.name == "strategies"){
							return <TableRowColumn key={index2} style={{fontFamily:'Roboto',backgroundColor:'inherit',paddingTop:0,paddingBottom:0,height:20}}>
										<div style={{backgroundColor:'inherit',borderStyle:'solid', borderWidth:1,borderColor:'#c7c7c7',height:32, fontSize:11, padding:8, overflow:'hidden'}} id={td.name}>
											<span>{this.strategiesToString(tr[td.name])}</span>
										</div>
									</TableRowColumn>
						}else if(td.name == "empty"){
							return <TableRowColumn key={index2} style={{fontFamily:'Roboto',backgroundColor:'inherit',paddingTop:0,paddingBottom:0,height:20}}></TableRowColumn>
						}
						// let value = Math.round(tr[td.name]*100)/100
						return (<TableRowColumn key={index2} style={{fontFamily:'Roboto',backgroundColor:'inherit',paddingTop:0,paddingBottom:0,height:20}}>
							<TextField

							id={tr.name+"-"+td.name}
							fullWidth={true}
							onChange={this.onChange.bind(this,tr)}
							underlineShow={false}
							value={tr[td.name]}
							inputStyle={tr[td.name+"Error"] ? {color:"red",fontSize:11, textAlign:'center'} : {color:'black',textAlign:'center',fontSize:11}}
							style={{fontFamily:'Roboto',borderStyle:'solid', borderWidth:1,borderColor:'#c7c7c7',height:32}}
						>
						</TextField></TableRowColumn>)
					})}
				</TableRow>
			))

		return(
			<div style={this.props.style}>
				<Paper zDepth={2} style={paperStyle} >
				{
				//<CLTable height="300px" tableData={this.state.sectorData} headerFields={this.state.tableHeader} showCheckboxes={false} stripedRows={true}/>
				}

					<Table


					>
						<TableHeader
							displaySelectAll={false}
				            adjustForCheckbox={false}
						>
							{tableHeader}
						</TableHeader>

						<TableBody

						            displayRowCheckbox={false}
						            stripedRows={true}
						          >

						          {tableBody}
						</TableBody>
					</Table>
				</Paper>
			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/js/components/SectorsTable.js